var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications'),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),_c('portal-target',{attrs:{"name":"modals","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }